import React, {ChangeEvent, useCallback, useRef, useState} from "react";
import {uploadPicture} from "../repository/Article.repo";


interface Props {
    inputAttrs: React.InputHTMLAttributes<HTMLInputElement>;
    url: string;
    onUpload: (file: string[]) => void;
    uploadKey: string;
}

export default function UploadBox(props: Props){

    /**
     * Creating ref object to get reference of input element on html dom
     */
    const refToInput = useRef<HTMLInputElement>(null);


    /**
     * Handling click to upload box
     */
    const onClickToBox = useCallback(() => {

        if(refToInput.current !== null){
            refToInput.current.click();
        }

    }, [refToInput]);

    /**
     * Uploading file to backend by selected repository
     */
    const uploadFile = useCallback(async (event: ChangeEvent<HTMLInputElement>) => {
        //@ts-ignore
        const upload = await uploadPicture(event.target.files);
        props.onUpload(upload);
    }, [props]);

    return (
        <React.Fragment>
            <input type='file' multiple={true} id={props.uploadKey} key={props.uploadKey} className="hiddenElement" accept={props.inputAttrs.accept} onChange={uploadFile} ref={refToInput} />
            <div className="uploadBoxFull" onClick={onClickToBox}>
                {(props.url !== '' && props.url !== null) ? (
                    <React.Fragment>
                        <React.Fragment>
                            <img alt="content image" src={`${props.url}`} />
                        </React.Fragment>
                    </React.Fragment>
                ): (
                    <div>Click to Select File</div>
                )}

            </div>
        </React.Fragment>
    )

}
